@if (!isOnline) {
  <div class="container-fluid py-3">
    @if (!isOnline) {
      <span class="badge bg-danger">Hors connexion</span>
    }
  </div>
}
<p-toast position="top-right"></p-toast>

@if (modalVersion) {
  <div style="height: 45px;color:var(--main-color);font-weight: bold;border:none; display: flex; align-items: center;"
    >
    <button type="button" pButton icon="pi pi-times"
      style="background-color: white;color: var(--main-color);font-size: 1rem; margin-right: 10px;"
    (click)="closeVersion()"></button>
    <span>Une nouvelle version est disponible ! ({{localVersion}} -> {{serverVersion}})</span>
    <button pButton type="button" label="Mettre à jour" class="p-button-text" style="color: var(--main-color); font-weight: bold;font-size: 1.2rem;"
    (click)="updateVersion()"></button>
    <span style="margin: 0 5px;">|</span>
    <button pButton type="button" label="Aide si la mise à jour ne fonctionne pas" class="p-button-text" style="color: var(--main-color); font-weight: bold;font-size: 0.85rem;"
    (click)="openRepairModal()"></button>
  </div>
}

<!--<div class="w-100 position-absolute bottom-0" *ngIf="modalPwaPlatform === 'ANDROID' || modalPwaPlatform === 'IOS' || modalPwaPlatform === 'isBrowser' ">
<div class="alert alert-secondary m-2">
  <button type="button" (click)="closePwa()">Fermer</button>
  &lt;!&ndash; Android &ndash;&gt;
  <div *ngIf="modalPwaPlatform === 'ANDROID' || 'isBrowser'" (click)="addToHomeScreen()">
    Ajouter l'application à l'écran d'accueil
  </div>
  &lt;!&ndash; iOS with Safari &ndash;&gt;
  <div *ngIf="modalPwaPlatform === 'IOS'">
    Pour ajouter l'application, utilisez le bouton menu
    <img src="assets/safari_action_button_38x50.png" class="ios-menu m-0" />
    et choisissez "Ajouter à l'écran d'accueil".
    <i class="bi bi-plus-square"></i>
  </div>
</div>
</div>-->


<main>
  <router-outlet></router-outlet>
</main>

<p-dialog header="Options de réparation" [(visible)]="displayRepairModal" [modal]="true"
  [style]="{width: '50vw', 'max-width': '600px'}" [draggable]="false" [resizable]="false">
  <p class="m-0 mb-3">Si la mise à jour automatique échoue, essayez les options suivantes dans l'ordre :</p>

  <div style="display: flex; flex-direction: column; gap: 1rem;">
    <div style="border: 1px solid #ffcc00; padding: 1rem; border-radius: 4px; background-color: #fffbef;">
      <div style="font-weight: bold; margin-bottom: 0.5rem;">1. Réparer (Vider le cache)</div>
      <div style="font-size: 0.9rem; color: #666; margin-bottom: 0.5rem;">Supprime les fichiers temporaires qui peuvent
      être corrompus.</div>
      <button pButton label="Vider le cache" icon="pi pi-trash" class="p-button-warning"
      (click)="cleanCacheandReload()"></button>
    </div>

    <div style="border: 1px solid #ff0000; padding: 1rem; border-radius: 4px; background-color: #fff0f0;">
      <div style="font-weight: bold; margin-bottom: 0.5rem; color: #d32f2f;">2. Réinitialisation complète du cache</div>
      <div style="font-size: 0.9rem; color: #d32f2f; margin-bottom: 0.5rem;">Attention : Peut nécessiter de réactiver
      les notifications. (N'efface pas vos données). À utiliser si le 1 a échoué</div>
      <button pButton label="Réinitialiser" icon="pi pi-exclamation-triangle" class="p-button-danger"
      (click)="hardReset()"></button>
    </div>

    <div style="border: 1px solid #1100ff; padding: 1rem; border-radius: 4px; background-color: #f0f4ff;">
      <div style="font-weight: bold; margin-bottom: 0.5rem; color: #1100ff;">3. Notifications</div>
      <div style="font-size: 0.9rem; color: #1100ff; margin-bottom: 0.5rem;">Réactiver les notifications après réinitialisation
      </div>
      <button pButton label="Réactiver les notifications" icon="pi pi-bell" class=""
      (click)="reSubscribeToNotifications()"></button>
    </div>

  </div>
</p-dialog>
